module.exports = __webpack_public_path__ + "media/images/new/icons/pro-black-96d8b01eb3bc5b1dd0b0ece914a66fb6.png";